// api.js

import axios from 'axios';
import { frontendRuntimeIdentityHeaders } from './runtime/runtimeIdentity';
const { resolveApiUrl } = require('./config/apiOrigin');

// Obté l'URL de l'API des de les variables d'entorn o usa localhost per defecte
const apiUrl = resolveApiUrl(process.env);

const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 🔹 Interceptor per afegir el token a totes les peticions
api.interceptors.request.use(config => {
    Object.assign(config.headers, frontendRuntimeIdentityHeaders());
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default api;
